import { v4 as uuidv4 } from 'uuid';
import { setContext } from '@apollo/client/link/context';

import { EnvConfiguration } from '../../configuration/EnvConfiguration';
import { getDeviceId } from '../../../lib/device/utils/info';

export interface ITracingHeaders {
  'x-client-trace-id': string;
  'x-app-version': string;
  'x-device-id': string;
}

export const tracingMiddleware = setContext(async () => {
  const deviceId = await getDeviceId();
  const tracingHeaders: ITracingHeaders = {
    'x-client-trace-id': uuidv4(),
    'x-app-version': EnvConfiguration.release,
    'x-device-id': deviceId,
  };
  return {
    headers: tracingHeaders,
  };
});
